/*! @pentacode/ui v0.1.0 */
import { t as e } from "./decorateMetadata-BhwOl-pv.js";
import { t } from "./decorate-DHgd5sZx.js";
import { t as n } from "./css-build-DICbZE45.js";
import { iconHref as r, onIconSpriteChange as i } from "./elements/icon/sprite-source.js";
import { LitElement as a, html as o, nothing as s, svg as c } from "lit";
import { customElement as l, property as u } from "lit/decorators.js";
//#endregion
//#region \0lit-plugin:css-sheet:./src/elements/icon/icon.css.js
var d = n(":host{vertical-align:-.375em;block-size:1.5em;inline-size:1.5em;display:inline-block}:host([hidden]){display:none}[part=glyph]{fill:currentColor;block-size:1.25em;inline-size:1.25em;display:block;position:relative;inset-block-start:50%;inset-inline-start:50%;translate:-50% -50%}"), f = class extends a {
	constructor(...e) {
		super(...e), this.label = "";
	}
	static {
		this.styles = [d];
	}
	connectedCallback() {
		super.connectedCallback(), this.unsubscribe = i(() => this.requestUpdate());
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this.unsubscribe?.();
	}
	render() {
		let e = !this.label;
		return o`<svg
            part="glyph"
            role=${e ? s : "img"}
            aria-label=${this.label || s}
            aria-hidden=${e ? "true" : s}
        >
            ${this.name ? c`<use href=${r(this.name)}></use>` : s}
        </svg>`;
	}
};
t([u({ reflect: !0 }), e("design:type", Object)], f.prototype, "name", void 0), t([u(), e("design:type", Object)], f.prototype, "label", void 0), f = t([l("ptc-ui-icon")], f);
//#endregion
export { f as t };

//# sourceMappingURL=icon-DGn-d_zv.js.map